<template>
  <div class="intro">
    <div class="top">
      <back-button cssClass="reverse"></back-button>
    </div>
    <tiny-slider ref="slider" :mouse-drag="false" :loop="false" :nav="true" :controls="false">
      <div class="slide welcome">
        <div class="wrapper">
          <div class="content">
            <h1 class="fontBold bodyFont">About The Garden</h1>
              <div class="textbox">
                <p>A  vast  palette  of  colors  and  textures,  flowers  and  foliage  makes  the  Perennial  Garden  a  living  work  of  art  throughout  the  year. This  Garden  is  arranged  in  a  series  of  “rooms,”  each  separate  space  defined  by  a  distinct  color  palette  or  seasonality.  All  the  rooms  contain  a  blend  of  perennials,  grasses,  bulbs,  shrubs,  and  trees  that  flower  or  produce  fruit  at  various  times,  producing color  and  fragrance  throughout  the  year.</p>
              </div>
              <p><img src="../assets/next-arrow-blk.png" @click="$router.push('/map')"></p>
              <!-- <p><img src="../assets/next-arrow-blk.png" @click="$refs.slider.goTo('next')"></p> -->
          </div>
        </div>
      </div>
      <!--<div class="slide inspiration">
         <div class="wrapper">
          <div class="content">
            <h1>More info</h1>
            <div class="textbox">
              <p>Sed vulputate nunc nec venenatis tempor. Ut neque ex, euismod eget hendrerit a, eleifend at libero. Nulla justo diam, iaculis ac mauris vel, ullamcorper semper libero. Duis vestibulum ante vitae libero mattis, vel molestie felis aliquet. Sed volutpat neque eget interdum vehicula. Ut felis magna, pulvinar imperdiet tortor quis, molestie faucibus tortor. Suspendisse in pharetra turpis, ut consectetur leo. Integer a venenatis risus, eu varius ipsum. Aenean hendrerit ex eget sem euismod scelerisque. Donec eu vestibulum risus.</p>
            </div>
            <p><img src="../assets/next-arrow-blk.png" @click="$refs.slider.goTo('next')"></p>
          </div>
        </div>
      </div>-->
      <!-- <div class="slide art">
        <div class="wrapper">
          <div class="content">
            <h1>Another info</h1>
            <div class="textbox">
              <p>Donec neque arcu, efficitur a quam scelerisque, suscipit vulputate ante. Nulla convallis tincidunt risus in feugiat. Mauris bibendum tortor tristique, placerat nulla ornare, molestie libero. Praesent scelerisque, nunc ac cursus tincidunt, elit justo mattis magna, vitae vehicula dolor erat rhoncus purus. Donec ullamcorper nunc eros, vitae sagittis quam sodales vel. Proin pretium mollis rutrum.</p>
            </div>
            <p><img src="../assets/next-arrow-blk.png" @click="$router.push('/map')"></p>
          </div>
        </div>
      </div> -->
    </tiny-slider>
  </div>
</template>

<script>
import TinySlider from 'vue-tiny-slider'
import 'tiny-slider/dist/tiny-slider.css'

export default {
  components: {
    'tiny-slider': TinySlider
  },
  name: 'Intro',
  props: {
    carouselIndex: {
      type:[String,Number],
      default: '0'
    }
  },
  methods: {
    distance (id) {
      return Math.round(this.$store.state.distances[id] * 3.2808)
    }
  },
  computed: {
    index () {
      return parseInt(this.carouselIndex)
    },
    areas () {
      return this.$store.state.exhibit_groups.areas
    }
  },
  mounted () {
    // force to our specific slide asap...
    this.$refs.slider.goTo(this.index)
  },
  activated () {
    this.$refs.slider.goTo(this.index)
  },
  beforeMount () {
    // window.loclyLocation.start()
  }
}
</script>

<style lang="scss">
// None scoped
.intro {

  overflow: hidden;

  .top {
    position:absolute;
    padding-top: 10px;
    padding-left: 10px;
  }

  .tns-outer {
    height: 100%;
    display: flex;

    .tns-inner {
      height: 100%;
      // overflow: hidden;

      .tns-carousel {
        height: 100%;
        // overflow: hidden;

        .tns-item {
          height: 100%;

          .wrapper {
            max-height: calc(100% - 40px) ;
            height: calc(100% - 40px) ;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .content {
              background-color: white;
              flex: 1 1 auto;

              display: flex;
              flex-direction: column;
              justify-content: space-around;

              overflow-y: auto;
              margin: 30px;
              padding: 20px;
            }

            .block {
              flex: 1;
              display: flex;
              flex-direction: column;
              background-size: cover;

              .content {
                // width: calc(100% - 40px);
                height: calc(100% - 40px);
                padding: 10px;
                // overflow: hidden;
                h1 {
                  font-size: 1.3em;
                }

              }

            }

          }

        }

      }

    }

    .tns-nav {
      background-color: black;
      padding: 25px 10px;
    }

    .tns-nav [aria-controls] {
      margin: 5px;
      display: inline-block;
      height: 20px;
      width: 20px;
      border: 2px solid #333;
      border-radius: 10px;
      background: #333;
      padding: 0;
      display: none;
    }

    .tns-nav [aria-controls].tns-nav-active {
      background: white;
    }

  }
  a {
    text-decoration: none;
    color: black;
  }
  p {
    font-size: 1rem;
  }
}
</style>

<style lang="scss" scoped>

  // Scoped
  .welcome {
    background: url("../assets/backgrounds/about-bg.jpg") center top no-repeat;
    background-size: cover;
  }

  /*.inspiration {
    background: url("../assets/exhibit/plants-bg.jpg") center top no-repeat;
    background-size: cover;
  }

  .art {
    background: url("../assets/exhibit/frangipani-bg.jpg") center top no-repeat;
    background-size: cover;
  }*/

  /*.goto {
    background: url("../assets/exhibit/pink-orange-flower-bg.jpg") center top no-repeat;
    background-size: cover;
  }*/
  .textbox {
    flex: 1;
  }

</style>
